import React from 'react'
import { useTranslation } from 'react-i18next'

import { HistoryDrawer } from '@/features/audit/components/HistoryDrawer'
import { EntityHistoryType, useEntityHistory } from '@/features/audit/hooks'

interface ProjectHistoryDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  entityId: string
}

const ProjectHistoryDrawer: React.FC<ProjectHistoryDrawerProps> = ({
  open,
  onOpenChange,
  entityId,
}) => {
  const { t } = useTranslation()

  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useEntityHistory(EntityHistoryType.PROJECT, entityId, open)

  const entries = data?.pages.flatMap((page) => page.data) ?? []

  return (
    <HistoryDrawer
      open={open}
      onOpenChange={onOpenChange}
      title={t('project.actions.history')}
      entries={entries}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
    />
  )
}

export default ProjectHistoryDrawer
